import bem from '../../../utils/bem';

const Link = ({ url, children, block, mods, base, extra, ...props }) => {
  return (
    <a
      href={url}
      className={bem(block || 'link', mods || [], base || '', extra || [])}
      {...props}
    >
      {children}
    </a>
  );
};

export default Link;
